import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid2,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FiSearch } from "react-icons/fi";
import { useQuery } from "@apollo/client";
import { GET_PRODUCT_ORIGINS } from "../../Utils/Queries";
import { useNavigate } from "react-router-dom";
import { RiSearch2Line } from "react-icons/ri";
import CustomModal from "../Common/CustomModal";

const ProductOrigins = () => {
  const { data, loading, error } = useQuery(GET_PRODUCT_ORIGINS);

  const productOrigins = data?.searchProductOrigins?.items || [];

  const [filteredOrigins, setFilteredOrigins] = useState([]);
  const [searchParams, setSearchParams] = useState("");

  const [openModal, setOpenModal] = useState(false);

  const [isMobileSearch, setIsMobileSearch] = useState(false);

  useEffect(() => {
    if (productOrigins) {
      setFilteredOrigins(productOrigins);
    }
  }, [productOrigins]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchParams(value);

    const filtered = productOrigins.filter((item) =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredOrigins(filtered);
  };

  const [sortedOrigins, setSortedOrigins] = useState([]);
  useEffect(() => {
    if (filteredOrigins) {
      const sortedProducts = [...filteredOrigins].sort((a, b) => {
        if (b.productCount > 0 && a.productCount === 0) return 1;
        if (a.productCount > 0 && b.productCount === 0) return -1;
        if (a.productCount > 0 && b.productCount > 0)
          return b.productCount - a.productCount;
        return 0;
      });

      setSortedOrigins(sortedProducts);
    }
  }, [filteredOrigins]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();

  const handleNavigate = (name, id) => {
    navigate(`/product-origins/${name}/${id}`);
  };

  return (
    <>
      <Box
        sx={{
          px: 2,
          pt: 1,
          pb: 2,
          my: 3,
          mx: 0,
          bgcolor: " #f2f2f2",
          boxShadow:
            " rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          borderRadius: "5px",
        }}
      >
        <Box>
          {isMobileSearch ? (
            <>
              <Box>
                <TextField
                  onChange={handleSearch}
                  value={searchParams}
                  size="small"
                  placeholder="Search Country"
                  fullWidth
                  InputProps={{
                    style: {
                      borderRadius: "8px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <FiSearch />{" "}
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontSize: {
                      lg: "24px",
                      xs: "16px",
                      md: "24px",
                      sm: "18px",
                    },
                    fontWeight: 700,
                  }}
                >
                  Our Product Origin
                </Typography>
                <Box sx={{}}>
                  {isMobile ? (
                    <Typography onClick={() => setIsMobileSearch(true)}>
                      {" "}
                      Search...{" "}
                    </Typography>
                  ) : (
                    <Button
                      onClick={() => setOpenModal(true)}
                      startIcon={<RiSearch2Line />}
                      sx={{ px: 2 }}
                    >
                      Search
                    </Button>
                  )}
                </Box>
              </Box>
            </>
          )}

          {!filteredOrigins || filteredOrigins?.length === 0 ? (
            <>
              <Box sx={{ my: 2 }}>
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#333",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                >
                  <b>
                    {searchParams
                      ? searchParams.toUpperCase()
                      : "Product origin"}
                  </b>{" "}
                  is not currently available
                </Typography>
              </Box>
            </>
          ) : (
            <div
              className={`${
                searchParams.length > 0 ? "remove-origins" : "origins"
              }`}
            >
              <div
                className={`${
                  searchParams.length > 0 ? "no-origins-slide" : "origins-slide"
                }`}
              >
                {sortedOrigins &&
                  sortedOrigins?.map((origin, index) => (
                    <div
                      className="origins-box"
                      key={index}
                      onClick={() => handleNavigate(origin.name, origin?._id)}
                    >
                      <img src={origin?.flagUrl} />

                      <InputLabel sx={{ color: "#333" }}>
                        {origin?.name}
                      </InputLabel>
                      <Typography>
                        ({origin?.productCount ? origin.productCount : 0})
                      </Typography>
                    </div>
                  ))}
              </div>
              {/* <div className="origins-slide">
                {sortedOrigins &&
                  sortedOrigins?.map((origin, index) => (
                    <div
                      className="origins-box"
                      key={index}
                      onClick={() => handleNavigate(origin.name, origin?._id)}
                    >
                      <img src={origin?.flagUrl} />

                      <InputLabel sx={{ color: "#333" }}>
                        {origin?.name}
                      </InputLabel>
                      <Typography>
                        {" "}
                        ({origin?.productCount ? origin.productCount : 0})
                      </Typography>
                    </div>
                  ))}
              </div> */}
            </div>
          )}
        </Box>
      </Box>

 <CustomModal
  open={openModal}
  onClose={() => setOpenModal(false)}
  width={{ md: 500 }}
  title="Our Product Origin"
>
  <Box sx={{ px: 4,  }}>
    {/* Static Search Field */}
    <TextField
      onChange={handleSearch}
      value={searchParams}
      placeholder="Search Country"
      fullWidth
      size="small"
      InputProps={{
        style: {
          borderRadius: "8px",
        },
        endAdornment: (
          <InputAdornment position="end">
            <FiSearch />
          </InputAdornment>
        ),
      }}
    />

    {/* Scrollable List Container */}
    <Box
      sx={{
        position: 'relative',
        maxHeight: 350, // adjust based on modal height
        overflowY: 'auto',
        mt: 2,
      }}
    >
      {/* Content */}
      {!filteredOrigins || filteredOrigins.length === 0 ? (
        <Box sx={{ my: 2 }}>
          <Typography
            sx={{
              textAlign: "center",
              color: "#333",
              fontWeight: 500,
              fontSize: "16px",
            }}
          >
            <b>
              {searchParams ? searchParams.toUpperCase() : "Product origin"}
            </b>{" "}
            is not currently available
          </Typography>
        </Box>
      ) : (
        <Grid2 container spacing={2} sx={{ background: 'linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',}}>
          {sortedOrigins?.map((origin, index) => (
            <Grid2
              size={2}
              key={index}
              onClick={() => handleNavigate(origin.name, origin?._id)}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img src={origin?.flagUrl} alt={origin.name} width={30} />
                <InputLabel sx={{ color: "#333" }}>{origin?.name}</InputLabel>
                <Typography>({origin?.productCount || 0})</Typography>
              </Box>
            </Grid2>
          ))}
        </Grid2>
      )}

      {/* Bottom Fade Overlay */}
    
    </Box>
  </Box>
    <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '100px',
          background: 'linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
          pointerEvents: 'none',
          zIndex: 10,
          
        }}
      />
</CustomModal>


    </>
  );
};

export default ProductOrigins;
